import React from "react";
import { Box, MenuItem, TextField, Typography } from "@mui/material";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import { useAlmacenes } from "../../hooks/useAlmacenes";
import { tituloLabelSx } from "./estilos";
import { normalizarCodigoAlmacen } from "../../utils/formatters";

/**
 * Nave en la que está contando el preparador: todo lo que puntee o escriba va a
 * esa nave, salvo en las tarjetas donde elija otra
 */
const SelectorNaveActiva = ({ value, onChange, disabled }) => {
    const { almacenes, getNombreAlmacen } = useAlmacenes();
    const codigos = [...new Set(almacenes.map((almacen) => normalizarCodigoAlmacen(almacen.CODIGO)))].sort();

    return (
        <Box>
            <Typography variant="body2" sx={tituloLabelSx}>
                <WarehouseIcon sx={{ fontSize: 18 }} /> Estoy contando en
            </Typography>
            <TextField
                select
                fullWidth
                size="small"
                value={value ?? ""}
                onChange={(evento) => onChange(evento.target.value || null)}
                disabled={disabled}
                SelectProps={{ displayEmpty: true }}
                helperText={value ? "Si un artículo está en otra nave, cámbiala solo para él en su tarjeta" : "Elige la nave antes de puntear"}
            >
                <MenuItem value="" disabled>
                    Elige nave...
                </MenuItem>
                {codigos.map((codigo) => (
                    <MenuItem key={codigo} value={codigo}>
                        {getNombreAlmacen(codigo)}
                    </MenuItem>
                ))}
            </TextField>
        </Box>
    );
};

export default SelectorNaveActiva;
